import {
  REDIRECTING_TO_SRP_ERROR,
  REDIRECTING_TO_SRP_ERROR_HEADING,
  NO_BOOK_DATA_ERROR,
  ERROR_HEADING,
  IS_MWEB_LITE,
  __GI_CB__
} from '@stencil/flights-constants';
import {
  getRepriceAddonsAPI,
  getBRPDetails,
  postRepriceAddonsAPI,
  baggageDataAndFareRulesAPI,
  getPriceAPI,
  coTravellerDataAPI,
  validatFormAPI,
  validatFormAPIV2,
  getAirlineInfoAPI,
  submitAPI,
  getTxnIdDetailsAPI,
  zcPriceAPI,
  getImpInfoAPI,
  getRepriseStreamData,
  submitV2API,
  validatSingleTravellerAPI,
  nudgeDynamicAPI
} from '@ibibo/hulk-apis';
import { PethoesAPI } from '@ibibo/pethoes-apis';
import {
  setRepriceData,
  setToken,
  setRulesData,
  setGetPriceData,
  setMinifiedData,
  setPromoLoading,
  setRepriceLoading,
  setUpdatingFareFamily,
  setGetPriceLoading,
  setSubmitLoading,
  setSubmitResponse,
  setGenericError,
  setSavedTravellersDetails,
  setRedirectToSrpError,
  setSeatsAmount,
  //setPriceLockSoldout,
  setBRPData,
  setImportantInfo,
  setBRPLoading,
  setSRPOfferShow,
  setSelectedSeats,
  setSeatInfo,
  setSelectedMealsText,
  setSelectedBaggageTxt,
  setSelectedSeatsText,
  setActiveAddons,
  setReviewWidgetOrder,
  setReviewBundles,
  setWebReviewWidgetOrder
} from './actions';
import {
  searchParamObjectToUrl,
  enableCss,
  disableCss,
  seatsRepriceRequest,
  searchStringToObject,
  getTravellerParams,
  getContactDetailsParams,
  checkDocumentTypeIfExists,
  getDetailsApiSerachDetails,
  processBrpDetailsApiData,
  removeQueryParamsFromBRP
} from '../utils/reviewPageUtils';
import {
  tokenSelector,
  txnIdSelector,
  flavourSelector,
  querySelector,
  submitRequestSelector,
  repriceRequestSelector,
  urlSearchParamSelector,
  repriceParamsSelector,
  rulesRequestSelector,
  isDomesticSelector,
  flightSearchDataSelector,
  contactDetailsSelector,
  directlyLandedSelector,
  travellerFormDataSelector,
  bookingReviewDataSelector,
  repriceRequestGroundupSelector,
  searchDetailsSelector,
  offersSelector,
  isMulticiySelector,
  brpDataSelector,
  shouldSendGstInDetailsSelector,
  repriceDataSelector,
  commonCTASelector,
  getPriceDataSelector,
  brpStateSelector,
  genericErrorSelector,
  submitTravellerRequestSelector,
  searchIdSelector,
  submitResponseSelector,
  newTravellersSelector
} from './selectors';
import { isStoreEmptySelector, staticInformationSelector } from '../../SRP/redux/selectors';
import { repriceRequestMulticitySelector } from '../../Multicity/redux/selectors';
import {
  setGetPriceTimerID,
  setContactDetails,
  setBookData,
  setSelectedMeals,
  setSelectedBaggage,
  setMealsAmount,
  setBaggageAmount,
  setAddonsRetried
} from './actions';
import { addStaticInformation } from '../../SRP/redux/actions';
import { setSrpFromRepriceAddons, setSrpMebLiteFromRepriceAddons } from '../../utils/common/utils';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';
import { gaPageViewThunk } from '@stencil/flights-ga-thunks';
import { flightsReducersPdtLoggingThunk, logBRPDetails } from '../../utils/common/common-thunks';
import { getTotal } from '@stencil/seats/src/utils/seats-utils';

import {
  sendPokusDataToNewrelic,
  flightsAnalyticsLoggingThunk
} from '../../utils/common/common-thunks';
import { selectedPromoCodeSelector, storeStatusSelector } from '../../SRP/redux-lite/selectors';

export const PRICING_FAILURE_MSG = 'Fare or Seat(s) not available with the airline.'; // TODO: put it in constants
const isBRPLite = IS_MWEB_LITE || false;

const pushPdtApiFailureError = (dispatch, err) => {
  dispatch(
    flightsReducersPdtLoggingThunk({ action_name: 'api_failure_error', error_message: err })
  );
};

export function selectReviewBundleStream(bundle) {
  return function (dispatch, getState) {
    dispatch(getReviewStreamLoad(bundle.cta.data, Boolean(isBRPLite), null));
  };
}

export function fetchStreamData(cb = () => {}) {
  return function (dispatch, getState) {
    const urlParams = urlSearchParamSelector(getState());
    const promoCode = selectedPromoCodeSelector(getState());
    const { t, rcoms = null, query_data, rid, rkeys, ...restUrlParams } = urlParams;

    const payload = {
      ...(t
        ? { token: t }
        : {
            query_data,
            rkeys: rkeys ?? JSON.stringify(Object.values(JSON.parse(rcoms) ?? {})),
            rid
          }),
      action: 'REVIEWLISTING',
      ...restUrlParams,
      ...(promoCode && { applied_addons: JSON.stringify(promoCode) })
    };

    dispatch(getReviewStreamLoad(payload, Boolean(isBRPLite), cb));
  };
}

export function updateReviewData(payload, callback) {
  return function (dispatch) {
    const payloadObj = {
      ...payload
    };

    dispatch(getReviewStreamLoad(payloadObj, Boolean(isBRPLite), callback));
  };
}

export const handleNudgeLogging = (tracking, pageType = 'REVIEW') => {
  return (dispatch, getState) => {
    try {
      const commonCTA = commonCTASelector(getState());
      const { pdt_events = [], omniture_id } = tracking || {};

      if (pdt_events?.length) {
        tracking.pdt_events.forEach(actionName => {
          dispatch(flightsReducersPdtLoggingThunk({ action_name: actionName?.name || actionName }));
        });
      }

      if (omniture_id && commonCTA?.[omniture_id]?.a) {
        dispatch(
          flightsAnalyticsLoggingThunk({
            omnitureInfo: { pageType, eventName: commonCTA?.[omniture_id]?.a || '' }
          })
        );
      }
    } catch (e) {
      // console.error(e);
    }
  };
};

export const handleNudgeAPItypeCTA = cta => {
  return (dispatch, getState) => {
    const isNewTravellerFlow = newTravellersSelector(getState());
    const { data } = cta;
    let { url: path, method, api_type, body, query_params } = data || {};

    if (api_type === 'SUBMIT') {
      let url = `${__GI_CB__}${path}`;
      dispatch(
        submitV2({
          nudgeParams: {
            url,
            method,
            body
          },
          skipCallValidation: true,
          skipSubmitCall: false,
          isNewTravellerFlow,
          queryParams: query_params
        })
      );
    }
  };
};

export function fetchData() {
  return function (dispatch, getState) {
    const repriceParams = repriceParamsSelector(getState());
    const token = tokenSelector(getState());
    const txnId = txnIdSelector(getState());
    const isMulticity = isMulticiySelector(getState());
    let repriceRequest = isBRPLite
      ? repriceRequestGroundupSelector(getState())
      : isMulticity
      ? repriceRequestMulticitySelector(getState())
      : repriceRequestSelector(getState());

    let searchDetails = Boolean(isBRPLite)
      ? searchDetailsSelector(getState())
      : !token
      ? getDetailsApiSerachDetails(repriceRequest)
      : {};
    const flightDetails = brpDataSelector(getState());

    const flavour = flavourSelector(getState());

    const localBookData = localStorage.getItem('bookingReviewData');

    if (repriceRequest && !repriceRequest.rid) {
      const urlParams = urlSearchParamSelector(getState());
      const promoCode = selectedPromoCodeSelector(getState());
      const { query_data } = urlParams;

      repriceRequest = {
        flavour,
        v: 1.6,
        ...urlParams,
        query_data: query_data?.split('-').slice(0, 9).join('-'),
        ...(promoCode && { applied_addons: JSON.stringify(promoCode) })
      };
      searchDetails = getDetailsApiSerachDetails(repriceRequest);
    }

    if (token) {
      // For reload and direct landing
      if (!flightDetails || !Object.keys(flightDetails).length || flightDetails.err) {
        dispatch(getBRPInfo({ t: token }));
      }
      dispatch(getRepriceAddonOnLoad(repriceParams, Boolean(isBRPLite)));
    } else if (txnId) {
      dispatch(getTxnDetailsOnLoad(repriceParams, Boolean(isBRPLite)));
      // } else if (repriceRequest && repriceRequest.minified_data) {
    } else if (repriceRequest) {
      if (isMulticity) {
        searchDetails['new_flow'] = true;
      }
      dispatch(getBRPInfo(searchDetails));
      dispatch(postRepriceAddon(repriceRequest, Boolean(isBRPLite)));
      if (searchDetails && isBRPLite && repriceRequest?.applied_addons) {
        dispatch(setSRPOfferShow(true));
      }
    } else if (localBookData) {
      try {
        const bookingReviewData = JSON.parse(localBookData);
        // const { gocashoffer, utm_source, utm_medium, campaign } = bookingReviewData;
        const {
          gocashoffer,
          gi_source = '',
          gi_medium = '',
          campaign,
          utm_medium = '',
          utm_source = ''
        } = bookingReviewData;

        let requestObj;
        const { si = {}, o = [], r = [] } = bookingReviewData.bookData || {};
        const { ri = {} } = si;
        const { rid = '' } = ri;
        const rcoms = {};
        if (o && o.length) {
          const onwFlt = o[0];
          rcoms[onwFlt.cid] = onwFlt.fk;
        }
        if (r && r.length) {
          const retFlt = r[0];
          rcoms[retFlt.cid] = retFlt.fk;
        }
        requestObj = {
          ...(gi_source ? { gi_source } : null),
          ...(gi_medium ? { gi_medium } : null),
          ...(utm_source ? { utm_source } : null),
          ...(utm_medium ? { utm_medium } : null),
          query_data:
            bookingReviewData &&
            bookingReviewData.queryParam &&
            bookingReviewData.queryParam.split('-').slice(0, 9).join('-'),
          flavour,
          v: 1.6,
          rid,
          rcoms: JSON.stringify(rcoms)
        };
        dispatch(setBookData(bookingReviewData));
        dispatch(postRepriceAddon(requestObj));
        localStorage.removeItem('bookingReviewData');
      } catch (e) {
        sendDataToNewrelic('Redirect Error: FetchData', e.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      }
    } else {
      sendDataToNewrelic('Redirect Error: FetchData', 'BookData Not found');
      dispatch(setRedirectToSrpError(NO_BOOK_DATA_ERROR, ERROR_HEADING));
    }
  };
}

const setUrl = (urlParams, t, directlyLanded = null, config) => {
  const { streaming = false } = config ?? {};
  let urlParamsCopy = { ...urlParams };
  if (!urlParamsCopy) {
    urlParamsCopy = {};
  }
  if (!urlParams && directlyLanded?.isDirectlyLanded) {
    urlParamsCopy = searchStringToObject(directlyLanded.searchString);
  } else if (location.search) {
    urlParamsCopy = searchStringToObject(location.search);
  }
  urlParamsCopy.t = t;
  urlParamsCopy.streaming = streaming;

  removeQueryParamsFromBRP(urlParamsCopy);
  const url = searchParamObjectToUrl(urlParamsCopy);
  window.history.replaceState({}, 'bookingToken', url);
};

function setRepriceAddonsData(response, isBRPLite = false) {
  return function (dispatch, getState) {
    const { brp } = getState();
    const urlParams = urlSearchParamSelector(getState());
    const directlyLanded = directlyLandedSelector(getState()); // for url params of srp
    const bookingReviewData = bookingReviewDataSelector(getState());
    const flavour = flavourSelector(getState());
    const isMulticity = isMulticiySelector(getState());

    const { repriceData, getPriceTimerId } = brp;
    dispatch(setRepriceLoading(false));
    if (window.location.href.includes('flight-review')) {
      if (response.error || response.err) {
        sendDataToNewrelic(
          'Redirect Error: setRepriceAddonsData',
          'RepriceAddons response error: ' + response.error || response.err || ''
        );
        dispatch(
          setRedirectToSrpError(
            response.error_message || response.msg || REDIRECTING_TO_SRP_ERROR,
            REDIRECTING_TO_SRP_ERROR_HEADING
          )
        );
      } else {
        // @TODO: monified_data no longer consumed, Need to remove
        if (response.minified_data) {
          if (response.minified_data.si) {
            dispatch(addStaticInformation(response.minified_data.si));
          }
          dispatch(setMinifiedData(response.minified_data));
        }
        if (response.query_data) {
          dispatch(
            setBookData({
              ...bookingReviewData,
              queryParam: isMulticity
                ? response.query_data
                : response.query_data +
                  (response.int || response?.ipd?.is_international ? '-I' : '-D')
            })
          );
        }
        if (repriceData.t !== response.t) {
          const t = response.t;
          dispatch(setToken(t));
          // @TODO: need to remove
          dispatch(getImportantInfo({ t, flavour }));
          // hit getPrice in interval
          if (getPriceTimerId) {
            clearInterval(getPriceTimerId);
          } else {
            dispatch(sendPokusDataToNewrelic('review'));
            setTimeout(() => {
              dispatch(gaPageViewThunk('FlightsBookingReviewPage', flightSearchDataSelector));
            }, 1000);

            dispatch(getPriceData({ token: t }, response.raa)); // Calling getPrice the first time
          }
          let timerId = setInterval(() => {
            return dispatch(getPriceData({ token: t }));
          }, response.rf || 300000);
          dispatch(setGetPriceTimerID(timerId));

          setUrl(urlParams, t, directlyLanded, null);
        }
        dispatch(setRepriceData(response));
        dispatch(getBaggageDataAndFareRules());

        const isIntl = response.int || response?.ipd?.is_international ? true : false;

        const { query_data, ft = 'R' } = response;
        if (query_data && !isBRPLite && !isMulticity) {
          const paramUrl = query_data.split('air-')[1];
          const params = `${paramUrl}-${isIntl ? 'I' : 'D'}`;
          const isStoreEmpty = isStoreEmptySelector(getState());
          if (isStoreEmpty) {
            setSrpFromRepriceAddons(params, dispatch);
          }
        } else if (query_data && isBRPLite) {
          const param = query_data.split('air-')[1];
          const searchString = `${param}-${ft}/`;
          const isStoreEmpty = storeStatusSelector(getState());
          if (isStoreEmpty) {
            setSrpMebLiteFromRepriceAddons(searchString, isIntl, dispatch);
          }
        }

        if (repriceData.t !== response.t) {
          if (!IS_MWEB_LITE) {
            dispatch(flightsAnalyticsLoggingThunk({ pdtInfo: { action_name: 'load_page' } }));
          } else {
            dispatch(logBRPDetails({ action_name: 'load_page', category: 'BRP' }));
          }
        }

        if (response.selected_meals_baggage?.meal) {
          dispatch(setSelectedMeals(response.selected_meals_baggage.meal));
          const mealAmt = response.ab.find(addon => addon.k.includes('Meal'))?.v || null;
          dispatch(setMealsAmount(mealAmt));
        } else {
          dispatch(setSelectedMeals({}));
          dispatch(setMealsAmount(null));
        }
        if (response.selected_meals_baggage?.baggage) {
          dispatch(setSelectedBaggage(response.selected_meals_baggage.baggage));
          const baggageAmt = response.ab.find(addon => addon.k.includes('Baggage'))?.v || null;
          dispatch(setBaggageAmount(baggageAmt));
        } else {
          dispatch(setSelectedBaggage({}));
          dispatch(setBaggageAmount(null));
        }
        if (response?.seat_info) {
          const selectedSeats = seatsRepriceRequest(response.seat_info);
          const seatAmt = selectedSeats.seat_data.length > 0 ? getTotal(response?.seat_info) : null;
          dispatch(setSeatsAmount(seatAmt));
        } else {
          dispatch(setSeatsAmount(null));
        }

        const contactDetails = contactDetailsSelector(getState());
        if (
          (!contactDetails.mobile || !contactDetails.email) &&
          (response.emp?.e || response.emp?.m)
        ) {
          dispatch(
            setContactDetails({
              mobile: contactDetails.mobile || response.emp.m,
              email: contactDetails.email || response.emp.e
            })
          );
        }
      }
    }
  };
}

export function updateGenericError(nudge, source) {
  return (dispatch, getState) => {
    dispatch(
      setGenericError({
        source: source,
        type: nudge?.type,
        nudge: nudge
      })
    );
    handleNudgeLogging(nudge.tracking);
  };
}

export function getRepriceAddonOnLoad(urlSearchParam, isBRPLite = false) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, subtype: msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));
    getRepriceAddonsAPI({ flavour, ...param, v: 1.6 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        sendDataToNewrelic('Redirect Error: getRepriceAddonOnLoad', err.message);
        if (isBRPLite) {
          logRepriceErrorForMwebLite(err.message);
        } else {
          pushPdtApiFailureError(dispatch, err.message);
        }
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function getImportantInfo(urlSearchParam) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    getImpInfoAPI(param, pdtApiFailureError)
      .then(response => {
        dispatch(setImportantInfo(response));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getImportantInfo', err.message);
      });
  };
}

export function getBRPInfo(urlSearchParam = {}) {
  return function (dispatch, getState) {
    const urlParams = urlSearchParamSelector(getState());
    const { utm_campaign = '', utm_medium = '', utm_source = '' } = urlParams || {};
    // const correlationIdForLogging = correlationIdForLoggingSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));
    dispatch(setBRPLoading(true));

    urlSearchParam = {
      ...urlSearchParam,
      ...(utm_campaign && { utm_campaign }),
      ...(utm_medium && { utm_medium }),
      ...(utm_source && { utm_source })
    };

    getBRPDetails(urlSearchParam, pdtApiFailureError)
      .then(response => {
        if (response && response.err) {
          pushPdtApiFailureError(dispatch, response?.msg || JSON.stringify(response?.err || ''));
          dispatch(
            setRedirectToSrpError(
              response?.msg || REDIRECTING_TO_SRP_ERROR,
              REDIRECTING_TO_SRP_ERROR_HEADING
            )
          );
          return;
        }
        const processedResponseData = processBrpDetailsApiData(response);
        dispatch(setBRPData(processedResponseData));
        dispatch(setBRPLoading(false));
        // if (!correlationIdForLogging) {
        //   if (!IS_MWEB_LITE) {
        //     dispatch(addCorrelationIdForLogging(processedResponseData?.query['search-id'] || ''));
        //   } else {

        //   }
        // }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function getTxnDetailsOnLoad(urlSearchParam, isBRPLite = false) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));
    if (param.fare_lock_txn_id) {
      delete Object.assign(param, { ['frl_txn_id']: param['fare_lock_txn_id'] })[
        'fare_lock_txn_id'
      ];
    }
    getTxnIdDetailsAPI({ flavour, ...param, v: 1.6 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getRepriceAddonOnLoad', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function retryRepriceAddon(urlSearchParam, isBRPLite = false) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const urlParams = urlSearchParamSelector(getState());
    const param = { addons_hit: true, ...urlParams, ...urlSearchParam };

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, subtype: msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));
    getRepriceAddonsAPI({ flavour, ...param, v: 1.6 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
        dispatch(setAddonsRetried(true));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: retryRepriceAddon', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
        dispatch(setAddonsRetried(true));
      });
  };
}

export function postRepriceAddon(param, isBRPLite = false) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, subtype: msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));

    postRepriceAddonsAPI({ flavour, ...param, v: 1.6 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        if (isBRPLite) {
          logRepriceErrorForMwebLite(err?.message);
        } else {
          pushPdtApiFailureError(dispatch, err.message);
        }
        sendDataToNewrelic('Redirect Error: PostRepriceAddon', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function applyRemoveAddons(
  appliedAddons,
  removeAddons,
  callback = null,
  selectedSeats = null
) {
  return function (dispatch, getState) {
    const token = tokenSelector(getState());
    const flavour = flavourSelector(getState());
    const repriceData = repriceDataSelector(getState());
    const data = { token, ...(!repriceData.reviewStreaming && { flavour }) };

    if (
      repriceData.reviewStreaming &&
      ((appliedAddons &&
        (appliedAddons.hasOwnProperty('seat') ||
          appliedAddons.hasOwnProperty('meals_baggage') ||
          appliedAddons.hasOwnProperty('covid_insurance'))) ||
        (removeAddons &&
          (removeAddons.hasOwnProperty('seat') ||
            removeAddons.hasOwnProperty('meals_baggage') ||
            removeAddons.hasOwnProperty('covid_insurance'))))
    ) {
      data.action = 'ADDONLISTING';
    }

    if (appliedAddons) {
      if (selectedSeats) {
        appliedAddons = { ...appliedAddons, seat: selectedSeats };
      }
      data['applied_addons'] = JSON.stringify(appliedAddons);
      if (appliedAddons.promo) {
        dispatch(setPromoLoading(appliedAddons.promo));
      }
    }
    if (removeAddons) {
      data['removed_addons'] = JSON.stringify(removeAddons);
      if (removeAddons.promo) {
        dispatch(setPromoLoading(removeAddons.promo));
      }
    }
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));

    if (repriceData.reviewStreaming) {
      const cb = (...args) => {
        dispatch(setActiveAddons(''));
        dispatch(setRepriceLoading(false));
        dispatch(setPromoLoading(''));
        if (callback) callback.apply(this, args);
      };

      return dispatch(updateReviewData(data, cb));
    }

    postRepriceAddonsAPI({ ...data, v: 1.6 }, pdtApiFailureError)
      .then((response: any) => {
        dispatch(setActiveAddons(''));
        dispatch(setRepriceLoading(false));
        dispatch(setPromoLoading(''));
        if (response.error) {
          if (callback) {
            callback(response.error);
          }
          sendDataToNewrelic('Redirect Error: applyRemoveAddons', response.error);
          dispatch(
            setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
          );
        } else {
          dispatch(setRepriceData(response));
          if (response?.call_fare_rules) {
            dispatch(getBaggageDataAndFareRules());
          }
          if (callback) {
            callback(null, response);
          }
        }
      })
      .catch(err => {
        dispatch(setActiveAddons(''));
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: applyRemoveAddons', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
        if (callback) {
          callback(err);
        }
        // TODO: Error popup & redirect to srp
      });
  };
}

export function updateFareFamily(id, rid, callback = null) {
  return function (dispatch, getState) {
    const query_data = querySelector(getState());
    const flavour = flavourSelector(getState());
    const offers = offersSelector(getState());
    const token = tokenSelector(getState());
    const urlParams = urlSearchParamSelector(getState());
    const repriceData = repriceDataSelector(getState());

    const data = {
      rcoms: JSON.stringify(id),
      rid,
      flavour,
      query_data: query_data?.split('-').slice(0, 9).join('-'),
      old_token: token,
      ...(offers?.appliedOffer
        ? { applied_addons: JSON.stringify({ promo: offers?.appliedOffer?.k }) }
        : null),
      ...(urlParams || {})
    };
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    dispatch(setRepriceLoading(true));
    dispatch(setUpdatingFareFamily(true));

    if (repriceData.reviewStreaming) {
      const updatedRkey = Object.values(id);
      const { t, ...restUrlParams } = urlParams || {};
      const dataObj = {
        rid,
        flavour,
        query_data: query_data?.split('-').slice(0, 9).join('-'),
        old_token: token,
        ...restUrlParams,
        rkeys: JSON.stringify(updatedRkey)
      };

      const cb = (...args) => {
        dispatch(setActiveAddons(''));
        dispatch(setPromoLoading(''));
        dispatch(setRepriceLoading(false));
        dispatch(setUpdatingFareFamily(false));
        if (callback) callback.apply(this, args);
      };

      return dispatch(updateReviewData(dataObj, cb));
    }

    postRepriceAddonsAPI({ ...data, v: 1.6 }, pdtApiFailureError)
      .then((response: any) => {
        dispatch(setRepriceLoading(false));
        dispatch(setUpdatingFareFamily(false));
        if (response.error) {
          if (callback) {
            callback(response.error);
          }
          dispatch(
            setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
          );
        } else {
          dispatch(setGetPriceTimerID(null));
          dispatch(setSelectedMeals({}));
          dispatch(setSelectedBaggage({}));
          dispatch(setSelectedSeats({}));
          dispatch(setSeatInfo(null));
          dispatch(setSelectedMealsText({}));
          dispatch(setSelectedBaggageTxt({}));
          dispatch(setSelectedSeatsText({}));
          dispatch(setRepriceAddonsData(response));
          if (callback) {
            callback();
          }
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: updatingFareFamilyOnError', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
        if (callback) {
          callback(err);
        }
      });
  };
}

export function getBaggageDataAndFareRules() {
  return function (dispatch, getState) {
    const param = rulesRequestSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    baggageDataAndFareRulesAPI(param, pdtApiFailureError)
      .then((response: any) => {
        dispatch(
          setRulesData(
            response,
            response?.baggage_data || null,
            response.minirules_data || null,
            response?.void_cancellation_data || null
          )
        );
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function getPriceData(param, retryAddons = false) {
  return function (dispatch, getState) {
    param.v = 1.6;

    dispatch(setGetPriceLoading(true));
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    getPriceAPI(param, pdtApiFailureError)
      .then((response: any) => {
        dispatch(setGetPriceData(response));
        dispatch(setGetPriceLoading(false));
        if (response.error) {
          sendDataToNewrelic('Redirect Error: getPriceData', response.error);
          dispatch(
            setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
          );
          // if (response.Refund && response.Refund === 'success' && response.is_fare_lock_txn_id) {
          //   dispatch(setPriceLockSoldout({ priceLockSoldout: true }));
          // } else {
          //   dispatch(
          //     setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
          //   );
          // }
          return;
        }
        if (response.farediff) {
          const dataObj = {
            token: param.token,
            extra_params: JSON.stringify({ farediff: response.farediff })
          };
          dispatch(postRepriceAddon(dataObj));
        }
        if (retryAddons) {
          dispatch(retryRepriceAddon({ t: param.token }));
        } else {
          dispatch(setAddonsRetried(true));
        }
        if (!response.farediff && !retryAddons) {
          const dataObj = {
            token: param.token
          };
          dispatch(postRepriceAddon(dataObj));
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getPriceData', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function gstLoggingPdt(dispatch, getState, paramsToSend) {
  const gstInFlagFromCB = shouldSendGstInDetailsSelector(getState());
  const strGstInFlagFromCB = gstInFlagFromCB.toString();
  const stateSent = paramsToSend.state !== undefined && paramsToSend.state !== null;
  const strStateSent = stateSent.toString();
  const stateIdSent = paramsToSend.state_id !== undefined && paramsToSend.state_id !== null;
  const strStateIdSent = stateIdSent.toString();
  dispatch(
    flightsReducersPdtLoggingThunk({
      action_name: `gst_in_logging_${gstInFlagFromCB}_${stateSent}_${stateIdSent}`
    })
  );
}

function triggerSubmitAPI({
  openFareChange = () => {},
  queryParams = {},
  requestData = {},
  nudgeParams = null,
  skipSubmitCall = false
} = {}) {
  // callback before opening Payments page
  return function (dispatch, getState) {
    const param = submitRequestSelector(getState());
    const updatedParam = isBRPLite ? { ...param, isgup: isBRPLite, ...requestData } : param;
    dispatch(setSubmitLoading(true));
    enableCss(['mStyles', 'html5Payment']); // enable Payments CSS
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    // Adding this pdtLogging to debug gstIn issue
    gstLoggingPdt(dispatch, getState, updatedParam);

    let promise = null;
    if (nudgeParams) {
      const { url, method, body } = nudgeParams;
      promise = nudgeDynamicAPI(url, method, body, queryParams, pdtApiFailureError);
    } else if (skipSubmitCall) {
      const submitResponse = submitResponseSelector(getState());
      promise = Promise.resolve({
        ...submitResponse,
        nudge: null
      });
    } else {
      promise = submitAPI(updatedParam, queryParams, pdtApiFailureError);
    }

    promise
      .then((response: any) => {
        const { success, nudge } = response;
        dispatch(setSubmitLoading(false));
        dispatch(setSubmitResponse(response));
        if (!success && nudge) {
          dispatch(updateGenericError(nudge, 'SUBMIT'));
          return;
        }
        if (response && response.ipc && response.ssd) {
          openFareChange();
          disableCss(['mStyles', 'html5Payment']);
          return;
        }
        if (response?.success && response?.payment_url) {
          dispatch(
            gaPageViewThunk(
              'FlightsBookingReviewPage',
              flightSearchDataSelector,
              response.payment_url
            )
          );
          return window.open(response.payment_url, '_self');
        }
        throw { message: response?.msg || '' };
      })
      .catch(err => {
        disableCss(['mStyles', 'html5Payment']);
        dispatch(setSubmitLoading(false));
        pushPdtApiFailureError(dispatch, err?.message);
        sendDataToNewrelic('Redirect Error: submitV2', 'Error: ' + err?.message);
        dispatch(
          setRedirectToSrpError(
            err?.message || REDIRECTING_TO_SRP_ERROR,
            REDIRECTING_TO_SRP_ERROR_HEADING
          )
        );
      });
  };
}

function triggerSubmitV2API({
  queryParams = {},
  requestData = {},
  nudgeParams = null,
  skipSubmitCall = false
} = {}) {
  return (dispatch, getState) => {
    const brp = brpStateSelector(getState());
    const crid = searchIdSelector(getState());
    const flavour = flavourSelector(getState());
    dispatch(setSubmitLoading(true));
    enableCss(['mStyles', 'html5Payment']);
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    const queryParameters = {
      ...queryParams,
      token: brp.token,
      crid,
      flavour
    };

    let promise = null;
    if (nudgeParams) {
      const { url, method, body } = nudgeParams;
      promise = nudgeDynamicAPI(url, method, body, queryParameters, pdtApiFailureError);
    } else if (skipSubmitCall) {
      const submitResponse = submitResponseSelector(getState());
      promise = Promise.resolve({
        ...submitResponse,
        nudge: null
      });
    } else {
      promise = submitV2API(requestData, queryParameters, pdtApiFailureError);
    }

    promise
      .then((response: any) => {
        const { paydata, nudge } = response;
        dispatch(setSubmitLoading(false));
        dispatch(setSubmitResponse(response));
        if (nudge) {
          dispatch(updateGenericError(nudge, 'SUBMIT'));
          return;
        }
        if (paydata?.payment_url) {
          dispatch(
            gaPageViewThunk(
              'FlightsBookingReviewPage',
              flightSearchDataSelector,
              paydata.payment_url
            )
          );
          return window.open(paydata.payment_url, '_self');
        }
        throw { message: response?.msg || '' };
      })
      .catch(err => {
        disableCss(['mStyles', 'html5Payment']);
        dispatch(setSubmitLoading(false));
        pushPdtApiFailureError(dispatch, err?.message);
        sendDataToNewrelic('Redirect Error: submitV2', 'Error: ' + err?.message);
        dispatch(
          setRedirectToSrpError(
            err?.message || REDIRECTING_TO_SRP_ERROR,
            REDIRECTING_TO_SRP_ERROR_HEADING
          )
        );
      });
  };
}

export const submitV2 = function submitV2Wrapper(options) {
  return function (dispatch, getState) {
    const brp = brpStateSelector(getState());
    const repriceData = repriceDataSelector(getState());
    const triggerSubmit = options.isNewTravellerFlow ? triggerSubmitV2API : triggerSubmitAPI;

    if (!options?.skipCallValidation && repriceData?.call_validation) {
      dispatch(
        getReviewStreamLoad(
          {
            token: brp.token,
            action: 'REVIEWLISTING',
            consent_key: 'CALL_VALIDATION'
          },
          Boolean(isBRPLite),
          err => {
            if (!err) {
              const genericError = genericErrorSelector(getState());
              if (!(genericError?.source === 'REVIEW-STREAM')) {
                dispatch(triggerSubmit(options));
              }
            }
          }
        )
      );
    } else {
      dispatch(triggerSubmit(options));
    }
  };
};

export function getSavedTravellersData() {
  return function (dispatch, getState) {
    const param = { action_type: 'getall', lob: 'DF' };
    const isDomestic = isDomesticSelector(getState());
    const travellerFormData = travellerFormDataSelector(getState());
    const travellerDocumentList = travellerFormData?.TRAVELER_DOCUMENT_LIST?.list || [];

    if (!isDomestic) {
      param.lob = 'IF';
    }
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    coTravellerDataAPI(param, pdtApiFailureError)
      .then((response: any) => {
        if (response.data && Array.isArray(response.data)) {
          dispatch(
            setSavedTravellersDetails(
              checkDocumentTypeIfExists(response.data, travellerDocumentList)
            )
          );
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function validationTravellerDetailsAPI(callback, param) {
  validatFormAPI(param)
    .then((response: any) => {
      callback(response);
    })
    .catch(err => {
      callback(null, err);
    });
}

export function validateEachTraveller(callback, paxDetail, paxType, token, flavour) {
  const param = getTravellerParams(paxDetail, paxType, token, flavour);
  validationTravellerDetailsAPI(callback, param);
}

export function validateContactDetailsFormApi(callback, contactDetails, token, flavour) {
  const param = getContactDetailsParams(contactDetails, token, flavour);
  validationTravellerDetailsAPI(callback, param);
}

export function validateGstDetailsFormApi(callback, gstDetails, token, flavour) {
  validationTravellerDetailsAPI(callback, { gstdata: JSON.stringify(gstDetails), token, flavour });
}

export function getAirlineInfo(
  callback,
  travellerInfo: { firstname?: string; gender?: string; buttonType?: string }
) {
  getAirlineInfoAPI()
    .then(response => {
      callback(response, travellerInfo);
    })
    .catch(err => {
      callback(null, travellerInfo);
    });
}

export function validateTravellersApi(
  callback,
  { isValidateFormV2 = false, queryParams = {} } = {}
) {
  return function (dispatch, getState) {
    const brp = brpStateSelector(getState());
    const crid = searchIdSelector(getState());
    const flavour = flavourSelector(getState());
    const param = isValidateFormV2
      ? submitTravellerRequestSelector(getState())
      : submitRequestSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    const promise = isValidateFormV2
      ? validatFormAPIV2(
          JSON.stringify(param),
          {
            token: brp.token,
            flavour,
            crid,
            ...queryParams
          },
          pdtApiFailureError
        )
      : validatFormAPI(param, pdtApiFailureError);
    promise
      .then((response: any) => {
        callback(response);
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function validateSingleTraveller(param, queryParams, callback) {
  return (dispatch, getState) => {
    const flavour = flavourSelector(getState());
    const brp = brpStateSelector(getState());
    const crid = searchIdSelector(getState());

    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    validatSingleTravellerAPI(
      JSON.stringify(param),
      {
        token: brp.token,
        flavour,
        crid,
        ...queryParams
      },
      pdtApiFailureError
    )
      .then((response: any) => {
        callback(response);
      })
      .catch(err => {
        callback(null, err);
      });
  };
}

export function fetchZCPriceDetailThunk(callback) {
  return function (dispatch, getState) {
    const param = {
      token: tokenSelector(getState())
    };
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    zcPriceAPI(param, pdtApiFailureError)
      .then(response => {
        callback(response);
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

// Pethos APIs

const getFirstKeyObject = (obj, k, index) =>
  obj && obj[k] && Object.keys(obj[k]).length && obj[k][Object.keys(obj[k])[index]];

export function getReviewPersuasion(callback, position, isSRP = false) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const param = {
      requestId: !isSRP
        ? tokenSelector(getState())
        : staticInformationSelector(getState())?.ri?.rid,
      funnelStep: !isSRP ? 'REVIEW' : 'LISTING',
      flavour
    };
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    PethoesAPI(param, pdtApiFailureError)
      .then((response: any) => {
        const index = response.positionlist?.indexOf(position);

        if (index >= 0) {
          const pLevelObj = getFirstKeyObject(response?.data?.c, 'p', index);
          const cpuLevelList = pLevelObj.cpu;
          const ioLevelList = pLevelObj.io;
          const persuasionArray = cpuLevelList || ioLevelList;
          const persuasionObject = persuasionArray.sort((a, b) => a.priority - b.priority)[0];

          if (
            persuasionObject &&
            persuasionObject.data &&
            typeof persuasionObject.data.value === 'string'
          ) {
            const data = JSON.parse(persuasionObject.data.value);
            callback(data);
          }
        }
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export const getRepriceReqDetails = (query, onwardSelectedFlight, returnSelectedFlight) => {
  const rid = query?.search_id;

  const flight = {};
  let onwardFlightKey = '',
    onwardFlightVal = '',
    returnFlightKey = '',
    returnFlightVal = '';
  if (onwardSelectedFlight && onwardSelectedFlight.id) {
    onwardFlightKey = Object.keys(onwardSelectedFlight?.id)[0];
    onwardFlightVal = Object.values(onwardSelectedFlight?.id)[0][0];
  }
  if (onwardFlightKey && onwardFlightKey) flight[onwardFlightKey] = onwardFlightVal;

  if (returnSelectedFlight && returnSelectedFlight.id) {
    returnFlightKey = Object.keys(returnSelectedFlight?.id)[0];
    returnFlightVal = Object.values(returnSelectedFlight?.id)[0][0];
  }
  if (returnFlightKey && returnFlightVal) flight[returnFlightKey] = returnFlightVal;

  return {
    rid,
    rcoms: flight
  };
};

function updateBookingData(payload) {
  const { query_data, is_international: isIntl, ft = 'R' } = payload;
  return function (dispatch, getState) {
    const isMulticity = isMulticiySelector(getState());
    if (query_data && !isBRPLite && !isMulticity) {
      const paramUrl = query_data.split('air-')[1];
      const params = `${paramUrl}-${isIntl ? 'I' : 'D'}`;
      const isStoreEmpty = isStoreEmptySelector(getState());
      if (isStoreEmpty) {
        setSrpFromRepriceAddons(params, dispatch);
      }
    } else if (query_data && isBRPLite) {
      const param = query_data.split('air-')[1];
      const searchString = `${param}-${ft}/`;
      const isStoreEmpty = storeStatusSelector(getState());
      if (isStoreEmpty) {
        setSrpMebLiteFromRepriceAddons(searchString, isIntl, dispatch);
      }
    }
    dispatch(
      setBookData({
        ...payload,
        queryParam: isMulticity ? query_data : `${query_data}${isIntl ? '-I' : '-D'}`
      })
    );
  };
}

function updateFareRules(payload) {
  const fareRulesData = payload;
  const { baggage_data, minirules_data, void_cancellation_data } = fareRulesData;
  return function (dispatch) {
    dispatch(
      setRulesData(
        fareRulesData,
        baggage_data || null,
        minirules_data || null,
        void_cancellation_data || null
      )
    );
  };
}

function updateMeals(mbData, payload) {
  const { selected_meal_info } = payload;

  const mealsRefData = mbData.mb.reduce((acc, val) => {
    acc[val.flt_key] = [val.fl];
    return acc;
  }, {});

  const selectedMealsData = Object.entries(selected_meal_info).reduce((acc, [key, value]) => {
    acc[mealsRefData[key]] = value.selected_meals.map(itm => itm.anc_code);
    return acc;
  }, {});

  return function (dispatch) {
    dispatch(setSelectedMeals(selectedMealsData));
  };
}

function updateBaggage(mbData, payload) {
  const { selected_baggage_info } = payload;

  const baggageRefData = mbData.mb.reduce((acc, val) => {
    acc[val.flt_key] = [val.fl];
    return acc;
  }, {});

  const selectedBaggageData = Object.entries(selected_baggage_info).reduce((acc, [key, value]) => {
    acc[baggageRefData[key]] = value.selected_baggage.map(itm => itm.anc_code);
    return acc;
  }, {});

  return function (dispatch) {
    dispatch(setSelectedBaggage(selectedBaggageData));
  };
}

function updateSeats(payload) {
  return function (dispatch) {
    dispatch(setSelectedSeats(seatsRepriceRequest(payload)));
  };
}

function updateCardsLayout(payload) {
  return function (dispatch) {
    dispatch(setReviewWidgetOrder(payload));
  };
}

function updateWebCardsLayout(payload) {
  return function (dispatch) {
    dispatch(setWebReviewWidgetOrder(payload));
  };
}

function updateBrpData(cards) {
  return function (dispatch, getState) {
    let brpData = brpDataSelector(getState());

    if (cards.flight_details) {
      brpData = { ...brpData, ...cards.flight_details };
    }

    if (cards.fare_family_upgrade) {
      brpData['fare_options'] = cards.fare_family_upgrade;
    }

    dispatch(setBRPData(brpData));
  };
}

function updateRepriseData(cards) {
  return function (dispatch, getState) {
    const repriceData = repriceDataSelector(getState());

    let repriceContent = repriceData;
    repriceContent.reviewStreaming = true;

    if (!repriceContent.l) repriceContent.l = [];

    if (cards.zero_cancellation) {
      repriceContent['zero_cancellation'] = cards.zero_cancellation.zc_details;
    }

    if (cards && cards.cabs && cards.cabs.cab_details) {
      const existingIndex = repriceContent.l.findIndex(itm => itm.t === 'cab_assistance');
      if (existingIndex !== -1) {
        repriceContent.l.splice(existingIndex, 1, cards.cabs.cab_details);
      } else {
        repriceContent.l.push(cards.cabs.cab_details);
      }
    }

    if (cards && cards.charity && cards.charity.charity_desktop) {
      const existingIndex = repriceContent.l.findIndex(itm => itm.t === 'charity');
      repriceContent.charity_opted = cards.charity.charity_desktop.ap;
      if (existingIndex !== -1) {
        repriceContent.l.splice(existingIndex, 1, cards.charity.charity_desktop);
      } else {
        repriceContent.l.push(cards.charity.charity_desktop);
      }
    }

    if (cards && cards.charity && cards.charity.charity) {
      const existingIndex = repriceContent.l.findIndex(itm => itm.t === 'charity');
      repriceContent.charity_opted = cards.charity.charity.ap;
      if (existingIndex !== -1) {
        repriceContent.l.splice(existingIndex, 1, cards.charity.charity);
      } else {
        repriceContent.l.push(cards.charity.charity);
      }
    }

    if (cards && cards.insurance && cards.insurance.insurance_review_details) {
      const existingIndex = repriceContent.l.findIndex(itm => itm.t === 'insurance');
      if (existingIndex !== -1) {
        repriceContent.l.splice(existingIndex, 1, cards.insurance.insurance_review_details);
      } else {
        repriceContent.l.push(cards.insurance.insurance_review_details);
      }
    }

    if (cards && cards.giff) {
      if (cards.giff.insurance) {
        const existingIndex = repriceContent.l.findIndex(itm => itm.t === 'insurance');
        if (existingIndex !== -1) {
          repriceContent.l.splice(existingIndex, 1, cards.giff.insurance.insurance_review_details);
        } else {
          repriceContent.l.push(cards.giff.insurance.insurance_review_details);
        }
      }
      if (cards.giff.zero_cancellation) {
        repriceContent['zero_cancellation'] = cards.giff.zero_cancellation.zc_details;
      }
      if (cards.giff.fdc?.fdc) {
        repriceContent['fdc'] = cards.giff.fdc.fdc;
      }
      repriceContent['giff'] = cards.giff.go_luxe;
    }

    if (cards && cards.gst) {
      repriceContent['should_show_gst_in'] = cards.gst.should_show_gst_in;
    }

    if (cards && cards.traveller_form_rules) {
      repriceContent['f_rules'] = cards.traveller_form_rules;
    }

    if (cards && cards.offer_details) {
      repriceContent = { ...repriceContent, ...cards.offer_details };
    }

    if (cards && cards.go_cash) {
      if (repriceContent.o && !Array.isArray(repriceContent.o)) {
        repriceContent.o = [];
      }
      const existingIndex = repriceContent.o.findIndex(itm => itm.t === 'goCash');
      if (existingIndex !== -1) {
        repriceContent.o.splice(existingIndex, 1, cards.go_cash.go);
      } else {
        repriceContent.o.push(cards.go_cash.go);
      }
    }

    if (cards && cards.fdc) {
      repriceContent = {
        ...repriceContent,
        fdc: cards.fdc?.fdc
      };
    }

    if (cards && cards.zero_cancellation) {
      repriceContent = {
        ...repriceContent,
        zero_cancellation: cards.zero_cancellation.zc_details
      };
    }

    if (cards && cards.cpfdc) {
      repriceContent = {
        ...repriceContent,
        cpfdc: cards.cpfdc?.cpfdc_card,
        fdc: cards.cpfdc?.fdc?.fdc,
        zero_cancellation: cards.cpfdc?.zero_cancellation.zc_details
      };
    }

    if (cards && cards.xsell_hotel) {
      repriceContent['xsell_hotel'] = cards.xsell_hotel;
    }

    if (cards && cards.seat) {
      repriceContent = {
        ...repriceContent,
        ...cards.seat
      };
    }

    if (cards && cards.meal_baggage) {
      repriceContent = {
        ...repriceContent,
        ...cards.meal_baggage
      };
    }

    if (cards && cards.imp_info) {
      repriceContent = {
        ...repriceContent,
        ...cards.imp_info
      };
    }

    if (cards && cards.extra_data) {
      repriceContent = {
        ...repriceContent,
        ...cards.extra_data
      };
    }

    if (cards && cards.addon_insurance) {
      repriceContent['cid'] = cards.addon_insurance.addon_insurance;
    }

    if (cards && cards.special_fares) {
      repriceContent['special_fare_widget'] = cards.special_fares;
    }

    if (cards && cards.common_texts && cards.common_texts.common_cta) {
      repriceContent['common_cta'] = cards.common_texts.common_cta;
    }

    if (cards && cards.go_tribe) {
      repriceContent = {
        ...repriceContent,
        ...cards.go_tribe
      };
    }

    if (cards && cards.dt) {
      repriceContent['delayed_ticketing'] = cards.dt;
    }

    if (cards && cards.selected_ssr_data) {
      repriceContent['selected_ssr_data'] = cards.selected_ssr_data;
    }

    /**
     * Mweb
     */
    if (cards && cards.clm) {
      repriceContent['clm_details'] = cards.clm;
    }

    dispatch(setRepriceData(structuredClone(repriceContent)));
  };
}

const updateAddonsSummary = fareSummary => {
  return dispatch => {
    const { fbs } = fareSummary;
    const addOns = fbs.find(itm => itm.key === 'Add_Ons');
    if (addOns) {
      const { fares } = addOns;
      fares.forEach(itm => {
        const amount = itm.meta?.invisible === 'true' ? null : itm.price;
        switch (itm.key) {
          case 'baggage':
            dispatch(setBaggageAmount(amount));
            break;
          case 'seat':
            dispatch(setSeatsAmount(amount));
            break;
          case 'meal':
            dispatch(setMealsAmount(amount));
            break;
          default:
            break;
        }
      });
    }
  };
};

export function getReviewStreamLoad(
  params = {},
  isBRPLite = false,
  onLastChunk,
  onClose = () => {}
) {
  return function (dispatch, getState) {
    const urlParams = urlSearchParamSelector(getState());
    const directlyLanded = directlyLandedSelector(getState());

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, subtype: msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };
    dispatch(setGetPriceLoading(true));
    getRepriseStreamData({
      requestedBody: {
        ...params
      },
      onError: err => {
        if (err.nudge) {
          dispatch(updateGenericError(err.nudge, 'REVIEW-STREAM'));
        } else {
          dispatch(
            setRedirectToSrpError(
              err.msg || REDIRECTING_TO_SRP_ERROR,
              REDIRECTING_TO_SRP_ERROR_HEADING
            )
          );
        }
        onLastChunk && onLastChunk(err);
        pdtApiFailureError(err);
      },
      onClose: onClose,
      onStream: response => {
        // console.log(response, 'RESPNSE');
        const contactDetails = contactDetailsSelector(getState());
        const repriceData = repriceDataSelector(getState());
        const getPrice = getPriceDataSelector(getState());
        const token = tokenSelector(getState());
        const { cards, t, is_last_chunk, nudge, tracking } = response;

        if (t) {
          dispatch(setToken(t));
          setUrl(urlParams, t, directlyLanded, { streaming: true });
        }

        if (t && t !== token) {
          if (!IS_MWEB_LITE) {
            dispatch(flightsAnalyticsLoggingThunk({ pdtInfo: { action_name: 'load_page' } }));
          } else {
            dispatch(logBRPDetails({ action_name: 'load_page', category: 'BRP' }));
          }
        }

        if (nudge) {
          dispatch(updateGenericError(nudge, 'REVIEW-STREAM'));
        }

        if (cards) {
          if (cards.basic_data) dispatch(updateBookingData(cards.basic_data));
          if (cards.imp_info) dispatch(setImportantInfo(cards.imp_info));
          if (cards.fare_rules) dispatch(updateFareRules(cards.fare_rules));
          if (cards.fare_summary) {
            dispatch(
              setGetPriceData({
                fs: cards.fare_summary,
                fare_diff_absorbed:
                  getPrice && getPrice.fare_diff_absorbed !== 0
                    ? getPrice.fare_diff_absorbed
                    : cards.fare_summary?.fare_diff_absorbed,
                farediff:
                  getPrice && getPrice.farediff !== 0
                    ? getPrice.farediff
                    : cards.fare_summary?.farediff
              })
            );
            dispatch(updateAddonsSummary(cards.fare_summary));
          }

          if (cards.selected_ssr_data) {
            const {
              selected_meal_info = {},
              selected_baggage_info = {},
              seat_info = {}
            } = cards.selected_ssr_data;
            if (cards.meal_baggage || repriceData.mb) {
              dispatch(
                updateMeals(cards.meal_baggage || repriceData, {
                  selected_meal_info
                })
              );
              dispatch(
                updateBaggage(cards.meal_baggage || repriceData, {
                  selected_baggage_info
                })
              );
            }

            dispatch(updateSeats(seat_info));
          }

          if (
            cards &&
            cards.extra_data &&
            contactDetails &&
            (cards.extra_data.mobile || cards.extra_data.email) &&
            (!contactDetails.email || !contactDetails.mobile)
          ) {
            const { mobilecode } = contactDetails;
            dispatch(
              setContactDetails({
                mobilecode,
                mobile: contactDetails.mobile || cards.extra_data.mobile || '',
                email: contactDetails.email || cards.extra_data.email || ''
              })
            );
          }

          if (cards.review_widget_order) {
            dispatch(updateCardsLayout(cards.review_widget_order));
          }

          if (cards.web_review_widget_order) {
            dispatch(updateWebCardsLayout(cards.web_review_widget_order));
          }

          if (cards.bundle_addons) {
            dispatch(setReviewBundles(cards.bundle_addons));
            dispatch(
              handleNudgeLogging({
                pdt_events: cards.bundle_addons.pdt_events || []
              })
            );
          }

          dispatch(updateRepriseData(cards));
          dispatch(updateBrpData(cards));
        }

        if (is_last_chunk) {
          dispatch(setAddonsRetried(true));
          dispatch(setGetPriceLoading(false));
          onLastChunk && onLastChunk(undefined, { tracking });
        }
      }
    });
  };
}
